import { render, staticRenderFns } from "./H2Block.vue?vue&type=template&id=6a4fefc9"
import script from "./H2Block.vue?vue&type=script&lang=js"
export * from "./H2Block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports